import { captureException } from "@sentry/react";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { APIError } from "@/api/error";
import { error as showErrorToast } from "./ToastProvider";

export const globalHandleError = (error: unknown) => {
  console.error(error);
  if (error instanceof APIError) {
    if (error.display) {
      if (error.isKind("FormValidationError")) {
        const description = Object.entries(error.data.formErrors)
          .map(([field, error]) => `${field}: ${error}`)
          .join("\n");
        showErrorToast(error.message, { description });
      } else {
        showErrorToast(error.message);
      }
    }
    if (error.capture) {
      captureException(error);
    }
  } else {
    captureException(error);
  }
};

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.supressGlobalError) return;
      globalHandleError(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _v, _c, mutation) => {
      if (mutation.meta?.suppressGlobalError) return;
      globalHandleError(error);
    },
  }),
});

export function QueryClientProviderWrapper({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
